import { provider } from "@grassrootly/api/providers";

export type RegisterPayload = {
  name: string;
  email: string;
  password: string;
};

export const Register = async (params: RegisterPayload): Promise<{ created: boolean }> =>
  provider.Request<RegisterPayload, { created: boolean }>("/auth/register", params);
